import Vue from 'vue'
import VueI18n from 'vue-i18n'

import esLocale from './locale/es.js'
import enLocale from './locale/en.js'
/*
import enLocale from './locale/en.js'
import glLocale from './locale/gl.js'
import euLocale from './locale/eu.js'
*/

Vue.use(VueI18n)

const messages = {
  Spanish: esLocale,
  English: enLocale
  /*
  Galician: glLocale,
  Euskera: euLocale
  */
}

const i18n = new VueI18n({
  locale: 'Spanish',
  messages,
  silentTranslationWarn: true
})

export default i18n



// WEBPACK FOOTER //
// ./src/lang/i18n.js